import { IconProps, iconA11yProps } from '../types';

export const MailList = ({ classNames, label }: IconProps) => (
    <svg
        className={classNames}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <path d="M12,18l-7,0c-1.097,0 -2,-0.903 -2,-2l0,-10c0,-1.097 0.903,-2 2,-2l14,0c1.097,0 2,0.903 2,2l0,5.5" />
        <path d="M3,6l9,6l9,-6" />
        <path d="M15,21l7,0" />
        <path d="M15,18l7,0" />
        <path d="M15,15l7,0" />
    </svg>
);
